import { defineMessages, FormattedMessage } from 'react-intl';

import { IconRemove } from '../../components/icons/IconRemove';
import type { MessageRemoverProps } from './remove/MessageRemover';
import { MessageRemover } from './remove/MessageRemover';
import { ThreadOptionsStructure } from './ThreadOptionStructure';

const messages = defineMessages({
  deleteLabel: { defaultMessage: 'Supprimer le message', id: 'lmA0Bs' },
});

/**
 *
 * @param props
 * @constructor
 */
export const DeleteMessageOption = (props: MessageRemoverProps) => {
  return (
    <MessageRemover {...props}>
      <ThreadOptionsStructure
        icon={<IconRemove size="m" />}
        title={<FormattedMessage {...messages.deleteLabel} />}
      />
    </MessageRemover>
  );
};
